import { AccessToken, OktaAuth } from '@okta/okta-auth-js';

declare const healConfig: any;

export const oktaAuth = new OktaAuth({
  issuer: healConfig.oktaIssuer,
  clientId: healConfig.oktaClientId,
  redirectUri: window.location.origin + '/implicit/callback',
  postLogoutRedirectUri: window.location.origin,
  scopes: ['openid', 'profile', 'email', 'offline_access'],
  pkce: true,
});

// Allow OktaAuth to be running as a service.
oktaAuth.start();

export function getAccessToken(): Promise<string> {
  return oktaAuth.tokenManager.getTokens().then((t) => t.accessToken?.accessToken ?? 'UNAUTHORIZED');
}

export function resolveUsername(token: AccessToken): string {
  let username = 'unknown';
  try {
    username = token.claims.sub;
  } catch {
    /** no-op */
  }
  return username;
}

export function isAuthorized(token: AccessToken): boolean {
  try {
    return (token.claims.groups as any).indexOf('SUPER_ADMIN') !== -1;
  } catch {
    return false;
  }
}

export function isOpsManager(token: AccessToken): boolean {
  try {
    return (token.claims.groups as any).indexOf('OPERATIONS_MANAGER') !== -1;
  } catch {
    return false;
  }
}

export async function logout() {
  oktaAuth.signOut();
}
